import { useState, useEffect } from 'react';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIsMobile = () => {
            // Check user agent for mobile devices
            const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
            const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            const isMobileUserAgent = mobileRegex.test(userAgent);

            // Check screen width (standard mobile breakpoint is usually < 768px)
            const isSmallScreen = window.innerWidth < 768;

            setIsMobile(isMobileUserAgent || isSmallScreen);
        };

        // Initial check
        checkIsMobile();

        // Listener for resize
        window.addEventListener('resize', checkIsMobile);

        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    return isMobile;
};

export default useIsMobile;
